/*
 * @Author: hzm
 * @Date: 2023-08-21 16:29:58
 * @Description:
 */
import http from '@/utils/request';

// 获取路由
export const getRouters = () => {
  return http.request({
    url: '/system/menu/getRouters',
    method: 'get',
  });
};
